import React, { useState, useEffect } from "react";
import {useBeforeFirstRender} from '../../hooks/customHooks';
import { handleEventInfoData } from "../../utils/storeConverter";
import { fireActionTriggerCustomEvent } from "../../utils/adobe-launch";
import "./VideoFramework.css";
import "./MyVideo.css";

import ExitActivityButton from "../UI/Button/ExitActivityButton";
import antenna from "../../assets/hero/antenna-img.png";
import mobileAntennaImg from "../../assets/hero/antenna.png";
import courtneyLogo from "../../assets/hero/courtneyLogo.png";
import mobileSpeaker from "../../assets/hero/Courtney_Speaker_Graphic.png";

import ReactVideoPlayer from "./ReactVideoJs/ReactVideo";

function MyVideo({
  storeId,
  handleDisposePlayer,
  videos,
  playerObj,
  changeVideoPlayerObj,
  activity
}) {
  const [videoNum, setVideoNum] = useState(0);
  const [isMobile, setMobile] = useState(
    window.innerWidth <= 750 || window.innerHeight < 900
  );

  const updateMediaWidth = () => {
    setMobile(window.innerWidth <= 750 || window.innerHeight < 900);
  };
  
  useEffect(() => {
    window.addEventListener("resize", updateMediaWidth);
    return () => window.removeEventListener("resize", updateMediaWidth);
  });
  // let playerObj = {...videoPlayerObj};
  const handleChangePlayerObject = (playerObj) => {
    changeVideoPlayerObj(playerObj);
  };
  const handlePlayVideo = (e) => {
    if (playerObj && playerObj.paused()) {
      handleEventInfoData({
        storeName: window.digitalData.pageInfo.page_name,
        page_name:
          window.digitalData.pageInfo.page_name + `:play ${activity}`,
        location_name: `courtney videos`,
      });
      fireActionTriggerCustomEvent(
        e.target,
        window.digitalData.event
      );
      playerObj.play();
    }
  };

  const handlePauseVideo = (e) => {
    if (playerObj && !playerObj.paused()) {
      handleEventInfoData({
        storeName: window.digitalData.pageInfo.page_name,
        page_name:
          window.digitalData.pageInfo.page_name + `:pause ${activity}`,
        location_name: `Courtney videos`,
      });
      fireActionTriggerCustomEvent(
        e.target,
        window.digitalData.event
      );
      playerObj.pause();
    }
  };

  const handlePreviousVideo = (e) => {
    handleEventInfoData({
      storeName: window.digitalData.pageInfo.page_name,
      page_name:
        window.digitalData.pageInfo.page_name + `:previous ${activity}`,
      location_name: `Courtney tour`,
    });
    fireActionTriggerCustomEvent(
      e.target,
      window.digitalData.event
    );
    setVideoNum((videoNum) =>
      videoNum > 0 ? videoNum - 1 : videos.length - 1
    );
    UpdatePlayer(videos[videoNum > 0 ? videoNum - 1 : videos.length - 1]);
  };

  const handleNextVideo = (e) => {
    handleEventInfoData({
      storeName: window.digitalData.pageInfo.page_name,
      page_name:
        window.digitalData.pageInfo.page_name + `:next ${activity}`,
      location_name: `Courtney tour`,
    });
    fireActionTriggerCustomEvent(
      e.target,
      window.digitalData.event
    );
    setVideoNum((videoNum) =>
      videoNum < videos.length - 1 ? videoNum + 1 : 0
    );
    UpdatePlayer(videos[videoNum < videos.length - 1 ? videoNum + 1 : 0]);
  };

  const GetPosterParams = (videoId) => {
    let idInString = videoId.toString();
    return idInString.length >= 32 || idInString.startsWith("6")
      ? "poster"
      : videoId;
  };

  const UpdatePlayer = (videoId) => {
    let videoSrc = `https://images.mattel.net/video/upload/sp_auto:maxres_360p/v1712439666/digital-games/american-girl/courtney-mall-game/${videoId}.m3u8`,
      videoPoster = `https://images.mattel.net/video/upload/q_auto/v1712439666/digital-games/american-girl/courtney-mall-game/${videoId}.jpg`;

    playerObj.tech_ && playerObj.tech_.clearTracks("text");
    playerObj.resetControlBarUI_();
    playerObj.loadTech_(playerObj.options_.techOrder[0], null);
    playerObj.remoteTextTracks();
    playerObj.remoteTextTrackEls();
    playerObj.poster_ = videoPoster;
    playerObj.techCall_("setPoster", videoPoster);
    playerObj.trigger("posterchange");
    playerObj.src(videoSrc);
    playerObj.load();
    // playerObj.ready(() => {
    //   playerObj.play();
    // });
    playerObj.on("error", (e) => {
      e.stopImmediatePropagation();
    });
    handleChangePlayerObject(playerObj);
  };

  const thumbnailSelector = (currentVideoId) => {
    let newVideoList = currentVideoId; //videos.indexOf(currentVideoId);
    let arr = [];
    if (newVideoList >= videos.length) {
      newVideoList = 0;
    }
    for (let i = newVideoList + 1; i < newVideoList + 3; i++) {
      videos[i] && arr.push(videos[i]);
    }
    return arr;
  };

  const thumbnails = (
    <div className="videoThumbContainer">
      {videos.length > 1 &&
        thumbnailSelector(videoNum).map((vidID) => (
          <div key={`thumbBackground ${vidID}`} className="thumbnailBackground">
            <img
              className="videoThumb"
              onClick={(e) => {
                UpdatePlayer(vidID);
                setVideoNum(videos.indexOf(vidID));
                handleEventInfoData({
                  storeName: window.digitalData.pageInfo.page_name,
                  page_name:
                    window.digitalData.pageInfo.page_name + `:play ${activity}`,
                  location_name: `Courtney tour`,
                });
                fireActionTriggerCustomEvent(
                  e.target,
                  window.digitalData.event
                );
              }}
              key={`videoId ${vidID}`}
              src={`https://images.mattel.net/video/upload/q_auto/v1712439666/digital-games/american-girl/courtney-mall-game/${vidID}.jpg`}
              alt={`Video Thumbnail for:${vidID}`}
            />
          </div>
        ))}
    </div>
  );

  const videoJsOptions = {
    controls: true,
    fluid: true,
    poster: `https://images.mattel.net/video/upload/q_auto/v1712439666/digital-games/american-girl/courtney-mall-game/${videos[videoNum]}.jpg`,
    sources: [
      {
        src: `https://images.mattel.net/video/upload/sp_auto:maxres_360p/v1712439666/digital-games/american-girl/courtney-mall-game/${videos[videoNum]}.m3u8`,
        type: "application/x-mpegURL",
      },
    ],
    crossorigin: "anonymous",
    preload: "auto",
    html: {
      textTrackSettings: false,
      nativeTextTracks: false,
      hlsjsConfig: {},
    },
    // aspectRatio: "21:11",
  };

  const mobileAntenna = (
    <img
      className="mobileTvAntenna"
      src={mobileAntennaImg}
      alt="mobile tv antenna"
    />
  );

  const desktopAntenna = (
    <img className="tvAntenna" src={antenna} alt="TV antenna" />
  );

  const speaker = (
    <img
      alt="tv speaker"
      id="speaker"
      src={mobileSpeaker}
    />
  );

  const previousNextButtons = (
    <div className="prevNextBtnContainer">
      <button onClick={ (e) => {
        handlePreviousVideo(e);
       }} 
      className="prevVid videoButton">
        Previous
      </button>
      <button onClick={ (e) => {
        handleNextVideo(e)
      }} 
      className="nextVid videoButton">
        Next
      </button>
    </div>
  );

  return (
    <div className="videoBackground">
      {isMobile ? mobileAntenna : desktopAntenna}

      <div className="MyVideo">
        <div className="logoContainer">
          {isMobile ? null : (
            <img
              className="videoCourtneyLogo"
              src={courtneyLogo}
              alt="courtney logo"
            />
          )}
        </div>
        <ExitActivityButton
          activity={activity}
          storeId={storeId}
          // handleDisposePlayer={handleDisposePlayer}
        />
        <div className="vMain">
          <div className="videoContainer">
            {/* <div
              id="deluxe-video-player"
              data-video-id={videos[videoNum]}
            ></div> */}
            <ReactVideoPlayer
              {...videoJsOptions}
              videoId={videos[videoNum]}
              playerObj={playerObj}
              handleChangePlayerObject={handleChangePlayerObject}
            />
            <div className="videoButtonContainer">
              <div className="videoButtons">
                <button
                  onClick={(e) => {
                    handlePlayVideo(e)
                }}
                className="playVid videoButton"
                >
                  Play
                </button>
                <button
                  onClick={(e) => {
                    handlePauseVideo(e);
                  }}
                  className="pauseVid videoButton"
                >
                  Pause
                </button>
                {videos.length > 1 ? previousNextButtons : null}
              </div>
                {isMobile ? speaker : null}
              {isMobile ? null : thumbnails}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyVideo;
